import { makeRequest } from 'utils/requestLogger';

export default (liveID, participationID) =>
  makeRequest(
    'put',
    `/api/live_discussions/${liveID}/participations/${participationID}/turn-off-audio-video`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/turnOffStudentParticipation.js